// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"177":"home","216":"forbidden","357":"unauthorized","523":"shop","571":"settings"}[chunkId] || chunkId) + "-legacy." + {"177":"c9206b01","216":"e789a513","357":"bd8050c9","523":"388385d3","571":"fcf83701","865":"0b9b8790","964":"d9fbeb37"}[chunkId] + ".js";
};